import React from 'react'

export default function MenuPerfil() {
  return (
    <div>
      <h1>Perfil 123</h1>
    </div>
  )
}
